const NetworkNoticeRoutes = [
  {
    path: '/network-notice',
    name: 'NetworkNotice',
    component: () => import('@/views/network-notice/network-notice'),
    meta: {
      layout: 'DefaultLayout',
      title: '全网商机',
      cache: true,
      inNavbar: true,
      pageType: 'public',
      routeGroup: '大数据服务'
    }
  }
]

export default NetworkNoticeRoutes
